import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
    BorderRadiusTheme,
    ButtonTheme,
    ColorTheme,
    GradientTheme,
    ShadowTheme,
    SpacingTheme,
    TextTheme,
} from "../../globaStyledComponents/globalStyledComponentsStyling";

// Only keep interfaces and styled components that are used in the codebase

interface NavbarProps {
    navbarMenu?: boolean;
    location: string;
}

export const Navbar = styled.nav<NavbarProps>`
    position: relative;
    @media (max-width: 767px) {
        position: ${(props) => (props.navbarMenu ? "fixed" : "relative")};
        display: ${(props) => (props.location.includes("/search") || props.location.includes("/collection") || props.location === "/" ? "none" : "flex")};
    }
    z-index: 101;
    background: ${(props) => {
        if (props.location.includes("/search")) {
            return "rgb(255, 255, 255, 0.85)";
        }
        if (props.location.includes("/list-your-place")) {
            return "rgba(255, 255, 255, 0.75)";
        }
        if (props.location.includes("/collection")) {
            return "rgba(0, 0, 0, 0.2)";
        }
        return props.location === "/" ? "rgba(250, 250, 250, 0.8)" : ColorTheme.White.color;
    }};
    backdrop-filter: ${props => props.location.includes("/search") || props.location.includes("/list-your-place") || props.location === "/" || props.location.includes("/collection") ? "blur(16px)" : "none"};
    border-top-right-radius: ${props => props.location.includes("/search") && window.innerWidth >= 1024 ? "16px" : "0"};
    margin: 0 auto;
    width: 100%;
    height: 60px;
    padding: 0 24px;
    display: ${(props) => (props.location.includes("/search") || props.location.includes("/listing") || props.location.includes("/saved") || props.location.includes("/trips") || props.location.includes("/messages-lite") || props.location.includes("/messages") || props.location.includes("/profile") || props.location.includes("/refer") || props.location.includes("/invite") || props.location.includes("/list-your-place") || props.location.includes("/collection") || props.location === "/" ? "flex" : "none")};
    flex-direction: row;
    align-items: center;
    justify-content: ${(props) => (props.location.includes("/search") ? "space-between" : "space-between")};
    ${(props) => props.location.includes("/search") && "gap: 24px;"}
    box-shadow: none;
    @media (min-width: 768px) {
        display: ${(props) => (props.location.includes("/book") || props.location.includes("hospitable")) && "none"};
        height: 80px;
        border-bottom: ${(props) =>
                props.location.includes("/trips") ||
                props.location.includes("/edit-profile") ||
                props.location.includes("/profile") ||
                props.location.includes("/security-settings") ||
                props.location.includes("/payment-settings") ||
                props.location.includes("/dashboard") ||
                props.location.includes("/stay") ||
                props.location.includes("/payout-settings") ||
                props.location.includes("/payouts") ||
                props.location.includes("/payout/") ||
                props.location.includes("/invoice") ||
                props.location.includes("/calendar") ||
                props.location.includes("/listings") ||
                props.location.includes("/edit-listing") ||
                props.location.includes("/all-bookings") ||
                props.location.includes("/book") ||
                props.location.includes("/change/") ||
                props.location.includes("/payments") ||
                props.location.includes("/inbox") ||
                props.location.includes("/messages")
                        ? `1px solid ${ColorTheme.Grey2.color}`
                        : "none"};
        ${(props) => props.location.includes("/trips") && "padding: 0 32px;"}
        ${(props) => props.location.includes("/stay") && ""}
        ${(props) => props.location.includes("/refer") && "padding: 0 max(calc((100% - 1280px) / 2), 80px);"}
        ${(props) => props.location.includes("/invite") && "padding: 0 max(calc((100% - 1280px) / 2), 80px);"}
        ${(props) => props.location.includes("/profile") && "padding: 0 32px;"}
        ${(props) => props.location.includes("/list-your-place") && "padding: 0 max(24px, calc((100% - 1120px) / 2));"}
        ${(props) => props.location === "/" && "padding: 0 24px 0 20px;"}
    }
    @media (min-width: 1024px) {
        ${(props) => (props.location === "/" || props.location.includes("/profile")) && "padding: 0 24px 0 24px;"}
    }
    @media (min-width: 1280px) {
        ${(props) => props.location.includes("/listing") && "padding: 0 calc(50% - 570px);"}
        ${(props) => props.location.includes("/trips") && "padding: 0 96px;"}
    }
`;

export const NavbarWrapper = styled.div<{
    location: string;
    navbarMenu?: boolean;
    navbarSearchMenuActivated?: boolean;
}>`
    position: ${(props) => (props.location.includes("/listing") ? "unset" : "fixed")};
    top: 0;
    width: 100%;
    max-width: 100vw;
    max-height: 60px;
    background: ${(props) => props.location.includes("/list-your-place") ? "transparent" : "transparent"};
    z-index: ${(props) => (props.navbarMenu ? "1002" : "100")};
    box-shadow: ${(props) => props.location.includes("/list-your-place") ? "none" : "rgba(0, 0, 0, 0.065)"};
    ${(props) => (
            props.location.includes("/listing") ||
            props.location.includes("/create-listing") ||
            props.location.includes("/saved") ||
            props.location.includes("/trips") ||
            props.location.includes("/messages-lite") ||
            props.location.includes("/messages") ||
            props.location.includes("/profile")
    ) && "display: none;"};
    @media (max-width: 767px) {
        ${(props) =>
            props.location.includes("/search") ||
            props.location.includes("/listing") ||
            props.location.includes("/saved") ||
            props.location.includes("/trips") ||
            props.location.includes("/messages-lite") ||
            props.location.includes("/messages") ||
            props.location.includes("/profile") ||
            props.location.includes("/refer") ||
            props.location.includes("/invite") ||
            props.location.includes("/list-your-place") ||
            props.location === "/"
                ? ""
                : "display: none;"}
    }
    @media (min-width: 768px) {
        max-height: 80px;
        box-shadow: ${(props) => (props.location.includes("-policy") || props.location.includes("-conditions") || props.location.includes("/list-your-place") ? "none !important" : null)};
    }
    @media (min-width: 1024px) {
        ${(props) => props.location.includes("/search") && !props.navbarSearchMenuActivated && `
            width: 63%;
            max-width: 1184px;
            margin-left: auto;
            margin-right: auto;
        `}
    }
    @media (min-width: 1920px) {
        ${(props) => props.location.includes("/search") && !props.navbarSearchMenuActivated && "width: 63%;"}
    }
`;

export const ColumnNavbar = styled.nav<NavbarProps>`
    position: relative;
    @media (max-width: 767px) {
        display: none;
    }
    z-index: 101;
    width: 64px;
    height: 100%;
    display: ${(props) => (props.location.includes("/book") ? "none" : "flex")};
    flex-direction: column;
    box-shadow: none;
`;

export const ColumnNavbarWrapper = styled.div<{
    location: string;
    navbarMenu?: boolean;
    navbarSearchMenuActivated?: boolean;
}>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 8px;
    width: 64px;
    height: 100vh;
    background: ${ColorTheme.White.color};
    //make sure the mobilenavbar menu is behind if navbarmenu is opened on mobile;
    z-index: ${(props) => (props.navbarMenu ? "1002" : "101")};
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: ${ColorTheme.Grey2.color};

    ${(props) =>
            (props.location.includes("create-listing") ||
                    props.location.includes("booking-request") ||
                    props.location.includes("/payout/") ||
                    props.location.includes("/profile") ||
                    props.location.includes("/invoice")) &&
            "display: none;"};
    @media (max-width: 767px) {
        display: none;
    }

    &:hover {
        border-width: 0;
    }
`;

interface ColumnNavbarHoverWrapperProps {
    navbarMenu: boolean;
}

export const ColumnNavbarHoverWrapper = styled.div<ColumnNavbarHoverWrapperProps>`
    position: absolute;
    top: 0;
    width: ${(props) => (props.navbarMenu ? "292px" : "64px")};
    height: 100%;
    background: ${(props) => (props.navbarMenu ? `${ColorTheme.White.color}` : "#f7f5f2")};
    border-radius: ${(props) => (props.navbarMenu ? "0px 12px 12px 0px" : "unset")};
    box-shadow: ${(props) => (props.navbarMenu ? "1px 3px 12px 0px rgba(0, 0, 0, 0.1)" : "unset")};
    transition: all 0.25s ease;

    ${(props) =>
            !props.navbarMenu &&
            `
      &:hover {
        background: ${ColorTheme.White.color};
        width: 292px;
        border-radius: 0px 12px 12px 0px;
        box-shadow: 1px 3px 12px 0px rgba(0, 0, 0, 0.1);
      }
    `}
`;

interface NavbarLogoHomeButtonWrapperProps {
    location?: string;
}

export const NavbarLogoHomeButtonWrapper = styled.div<NavbarLogoHomeButtonWrapperProps>`
    z-index: 10;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    justify-self: flex-start;
    ${(props) => !props.location?.includes("/search") && "flex-grow: 1;"}
    ${(props) => !props.location?.includes("/search") && "flex-basis: 0;"}
`;

export const NavbarLogoHomeButton = styled.button`
    height: 28px;
    background: transparent;
    border: none;
    cursor: pointer;

    @media (min-width: 768px) {
        height: 32px;
    }
`;

interface NavbarLogoImageProps {
    location?: string;
}

export const NavbarLogoImage = styled.img<NavbarLogoImageProps>`
    height: 28px;

    @media (min-width: 768px) {
        height: 32px;
    }
    @media (min-width: 767px) and (max-width: 1024px) {
        display: ${(props) => !props.location?.includes("/invite") && "none"};
    }
`;

export const NavbarLogoImageTablet = styled.img`
    height: 32px;
    display: none;

    @media (min-width: 768px) and (max-width: 1024px) {
        display: block;
        height: 32px;
    }
`;

export const ColumnNavbarLogoImage = styled.img`
    height: 32px;
    width: 32px;
    @media (max-width: 767px) {
        display: none;
    }
`;

export const ColumnNavbarLogoHomeButton = styled.button`
    height: 32px;
    background: transparent;
    border: none;
    cursor: pointer;

    @media (max-width: 767px) {
        display: none;
    }
`;

export const ColumnNavbarLogoHomeButtonWrapper = styled.div`
    z-index: 10;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 16px 24px 16px;
`;

interface NavbarRightContentWrapperProps {
    pathname: string;
}

export const NavbarRightContentWrapper = styled.div<NavbarRightContentWrapperProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;
    flex-basis: 0;
    ${(props) => props.pathname.includes("/search") && "display: none;"}
`;

interface ColumnNavbarProfileWrapperProps {
    isHidden: boolean;
}

export const ColumnNavbarProfileWrapper = styled.div<ColumnNavbarProfileWrapperProps>`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const ColumnNavbarProfileImageButton = styled.div`
    display: flex;
    width: 100%;
    height: 55px;
    object-fit: cover;
    cursor: pointer;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    border-radius: 12px;
    transition: background-color 0.3s;
    user-select: none;
`;

export const DashboardSidebarDesktopToHomePageWrapper = styled.button`
    height: 48px;
    width: 48px;
    text-decoration: none;
    background-color: #f7f5f2;
    display: flex;
    align-items: center;
    padding: 0 14px;
    cursor: pointer;
    border: none;
    border-radius: 12px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #eeeae6;
    }
`;

export const ColumnNavbarDesktopHomeIcon = styled.img`
    height: 20px;
    width: 20px;
`;

export const ColumnNavbarProfileImage = styled.img`
    height: 40px;
    width: 40px;
    border: 2px solid ${ColorTheme.White.color};
    box-shadow: 1px 3px 12px 0 rgba(0, 0, 0, 0.1);
    object-fit: cover;
    border-radius: 50%;
`;

export const ColumnNavbarHostInfoWrapper = styled.div`
    margin-left: 12px;
    display: block;
    align-items: center;
    justify-content: start;
    cursor: pointer;
    border: none;
`;

export const ColumnNavbarHostModelWrapper = styled.div`
    margin-left: 20px;
    display: block;
    align-items: center;
    justify-content: start;
    cursor: pointer;
    border: none;
`;

export const ColumnNavbarHostInfoTitle = styled.div`
    font-size: ${TextTheme.sans_350_semi.fontSize};
    font-family: ${TextTheme.sans_350_semi.fontFamily};
    line-height: ${TextTheme.sans_350_semi.lineHeight};
    margin-bottom: 2px;
`;

export const ColumnNavbarHostInfoSubtitle = styled.div`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Grey.color};
`;

interface NavbarDesktopListYourPlaceWrapperProps {
    location: string;
    isHomeAISearchVisible: boolean;
    isWhiteOnHome?: boolean;
}

export const NavbarDesktopListYourPlaceWrapper = styled.button<NavbarDesktopListYourPlaceWrapperProps>`
    padding: 11px 12px;
    border: none;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    text-decoration: none;
    background-color: transparent;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
    color: ${props => (props.location.includes("/collection") || (props.location === "/" && props.isWhiteOnHome)) ? ColorTheme.White.color : ColorTheme.Black.color};
    cursor: pointer;

    &:hover {
        background-color: ${props => (props.location.includes("/collection") || (props.location === "/" && props.isWhiteOnHome)) ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.04)"};
        transition: 125ms;
    }

    @media (max-width: 1023px) {
        display: none;
    }
`;

export const NavbarProfileNotificationWrapper = styled.button`
    /* Notifications hidden on mobile until complete */
    display: none;
    position: relative;
    @media (min-width: 768px) {
        width: 40px;
        height: 40px;
        background-color: transparent;
        border: none;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            background-color: rgba(0,0,0,0.04);
            transition: 125ms;
        }
    }
`;

interface NavbarProfileUnreadNotificationAlertProps {
    guestMode: boolean;
}

export const NavbarProfileUnreadNotificationAlert = styled.div<NavbarProfileUnreadNotificationAlertProps>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => (props.guestMode ? ColorTheme.Red.color : ColorTheme.Blue.color)};
    align-self: flex-start;
    justify-self: flex-end;
`;

export const NavbarProfileNotificationImage = styled.img`
    height: 24px;
    width: 24px;
`;

export const NavbarProfileImageButton = styled.div`
    position: relative;
    z-index: 100;
    margin-left: 14px;
    width: 44px;
    height: 44px;
    transition: 125ms;
    border: 3px solid rgba(255, 255, 255, 0.75);
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.12);
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;

    &:hover {
        box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.12);
    }
`;

export const NavbarProfileImage = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;
`;

interface NavbarMenuWrapperProps {
    isColumn?: boolean;
}

export const NavbarMenuWrapper = styled.div<NavbarMenuWrapperProps>`
    position: absolute;
    justify-self: flex-end;
    ${(props) => (props.isColumn ? "left: 16px;" : "right: 0;")}
    ${(props) => (props.isColumn ? "bottom: 72px;" : "top: 0;")}
    width: 100%;
    height: calc(100dvh - 60px);
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    padding: 60px ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_400.padding};
    text-align: left;
    z-index: 10010;

    @media (min-width: 768px) {
        position: fixed;
        min-height: unset;
        height: fit-content;
        width: ${(props) => (props.isColumn ? "232px" : "240px")};
        border-radius: 16px;
        padding: 16px 20px;
        margin-top: 56px;
        box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    }

    @media (min-width: 1024px) {
        ${(props) => !props.isColumn && `
            right: ${window.location.pathname === '/search' ? 'calc(24px + 60vw)' : '24px'};
            top: ${window.location.pathname === '/search' ? '80px' : '80px'};
            margin-top: 0;
        `}
    }
`;

export const NavbarMenuTextItemWrapper = styled(Link)`
    height: 64px;
    display: flex;
    justify-content: space-between;
    text-decoration: none;

    padding: 13px 20px;
    margin: 0 -20px;

    &:hover {
        background-color: ${ColorTheme.Grey5.color};
    }
`;

export const NavbarMenuTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const NavbarMenuText1 = styled.div`
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: "Altform Semibold";
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    margin-bottom: 4px;
    text-align: left;
`;

export const NavbarMenuText2 = styled.div`
    font-size: ${TextTheme.sans_200.fontSize};
    font-family: ${TextTheme.sans_200.fontFamily};
    color: ${ColorTheme.Grey.color};
    line-height: ${TextTheme.sans_200.lineHeight};
    text-align: left;
`;

export const NavbarMenuRedDot = styled.div`
    background-color: red;
    border-radius: 50%;
    margin-top: 5px;
    width: 8px;
    height: 8px;
    align-items: right;
`;

export const NavbarMenuBtn = styled.button`
    display: flex;
    height: 44px;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    margin: 0;
    cursor: pointer;
    border: none;
    background: none;
    text-align: left;
    align-items: center;
    padding: 0;
    text-decoration: none;
    padding: 13px 20px;
    margin: 0 -20px;

    &:hover {
        background-color: ${ColorTheme.Grey5.color};
    }
`;

export const NavbarMenuItem = styled(Link)`
    display: flex;
    height: 44px;
    gap: ${SpacingTheme.spacing_300.gap};
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    margin: 0;
    cursor: pointer;
    border: none;
    background: none;
    text-align: left;
    align-items: center;
    padding: 13px 20px;
    text-decoration: none;
    margin: 0 -20px;

    &:hover {
        background-color: rgba(250, 250, 250, 0.8);
    }
`;

export const NavbarMenuDivider = styled.span`
    height: 1px;
    width: 100%;
    background: ${ColorTheme.Grey2.color};
    margin: ${SpacingTheme.spacing_200.margin} 0;
`;

export const NavbarMenuItemMainItemOutsideLink = styled.a`
    height: 44px;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    display: flex;
    align-items: center;
    gap: ${SpacingTheme.spacing_300.gap};
    cursor: pointer;
    text-decoration: none;
    padding: 13px 20px;
    margin: 0 -20px;

    &:hover {
        background-color: rgba(250, 250, 250, 0.8);
    }
`;

export const NavbarMenuItemMainIcon = styled.svg`
    height: 20px;
    width: 20px;
    margin-top: 2px;
    object-fit: cover;
`;

export const NavbarCreateListingExitButton = styled.button`
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${TextTheme.sans_1000_semi.fontFamily};
    line-height: 0;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid ${ColorTheme.White.color};
    text-align: center;
    padding: 0 24px;
    height: 44px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    transition: 125ms;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);

    &:hover {
        background: rgba(255, 255, 255, 0.85);
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
        border: 1px solid ${ColorTheme.White.color};
    }
    &:active {
        background: rgba(255, 255, 255, 0.85);
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
        border: 1px solid ${ColorTheme.White.color};
    }
`;

export const NavbarCreateListingIcon = styled.svg`
    width: 16px;
    height: 16px;
    margin: ${SpacingTheme.spacing_300.margin} ${SpacingTheme.spacing_250.margin} ${SpacingTheme.spacing_300.margin} 0;
`;

export const SaveAndExitPopupWrapper = styled.div`
    width: 100%;
    min-height: calc(100vh - 12px);
    position: fixed;
    background: ${ColorTheme.White.color};
    z-index: 102;
    left: 0;
    bottom: 0;
    border-radius: 32px 32px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    justify-content: space-between;

    @media (min-width: 768px) {
        width: 560px;
        border-radius: 32px;
        min-height: unset;
        height: 600px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const SaveAndExitPopupContent = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
`;

export const SaveAndExitPopupContentTitle = styled.p`
    font-size: ${TextTheme.sans_600_semi.fontSize};
    line-height: ${TextTheme.sans_600_semi.lineHeight};
    font-family: ${TextTheme.sans_600_semi.fontFamily};
    margin: 0;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_800_bold.fontSize};
        font-weight: ${TextTheme.sans_800_bold.fontWeight};
        line-height: ${TextTheme.sans_800_bold.lineHeight};
    }
`;

export const SaveAndExitPopupContentSubtitle = styled.p`
    margin: 0;
    margin-top: 12px;
    max-width: 240px;
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};
    line-height: ${TextTheme.sans_400.lineHeight};
`;

export const SaveAndExitPopupContentImage = styled.img`
    height: 64px;
    width: 64px;
    object-fit: cover;
    margin-bottom: 32px;

    @media (min-width: 768px) {
        height: 80px;
        width: 80px;
    }
`;

export const SaveAndExitPopupButtonWrapper = styled.div`
    width: calc(100% - 48px);
    padding: ${SpacingTheme.spacing_300.padding} 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (min-width: 768px) {
        border: none;
        padding: ${SpacingTheme.spacing_400.padding} 0;
        margin: 0;
    }
`;

export const SaveAndExitPopupCancelButton = styled.button`
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    text-decoration: underline;
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    color: ${ColorTheme.Black.color};
`;

export const SaveAndExitPopupExitButton = styled.button`
    height: 48px;
    width: 104px;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    color: ${ColorTheme.White.color};
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    text-decoration: none;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border: none;
    background: ${ColorTheme.Blue.color};

    @media (min-width: 768px) {
        width: 104px;
    }
`;

export const NotificationDropDownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 92px;
    padding-bottom: 16px;
    width: 100%;
    height: 100%;
    background: ${ColorTheme.White.color};
    overflow-y: auto;

    ::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 56px;
        padding: ${SpacingTheme.spacing_400.padding} 0;
        width: 448px;
        max-height: 720px;
        height: calc(100vh - 80px);
        border-radius: ${BorderRadiusTheme.radius_16.borderRadius};
        box-shadow: ${ShadowTheme.shadow_100.boxShadow};
        background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(16px) !important;
    }
`;

export const NotificationDropDownTitle = styled.h1`
    font-size: ${TextTheme.sans_900_semi.fontSize};
    font-family: ${TextTheme.sans_900_semi.fontFamily};
    line-height: ${TextTheme.sans_900_semi.lineHeight};
    padding: 0 24px;
    margin-bottom: 24px;
    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_700_semi.fontSize};
        font-family: ${TextTheme.sans_700_semi.fontFamily};
        line-height: ${TextTheme.sans_700_semi.lineHeight};
        margin-bottom: 12px;
    }
`;

export const NotificationDropDownNoContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${SpacingTheme.spacing_250.gap};
    margin: ${SpacingTheme.spacing_400.margin} ${SpacingTheme.spacing_400.margin} 0;
    width: 240px;
    @media (min-width: 768px) {
        align-items: center;
        margin: 64px auto 0;
    }
`;

export const NotificationDropDownNoContentTitle = styled.h1`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    color: ${ColorTheme.Grey1.color};
    text-align: left;
    @media (min-width: 768px) {
        text-align: center;
    }
`;

export const NotificationDropDownNoContentSubTitle = styled.p`
    font-size: ${TextTheme.sans_500.fontSize};
    font-family: ${TextTheme.sans_500.fontFamily};
    line-height: ${TextTheme.sans_500.lineHeight};
    color: ${ColorTheme.Grey1.color};
    text-align: left;
    @media (min-width: 768px) {
        text-align: center;
    }
`;
